module.exports = __webpack_public_path__ + "img/labmemtest_logo_tc.350401f4.png";